import React, { useState } from 'react'

import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'

import { Icon, Text } from '@mxenabled/mxui'

interface InformationTooltipProps {
  body: string
  iconName?: string
  title: string
}

const InformationTooltip: React.FC<InformationTooltipProps> = ({
  body,
  iconName = 'info',
  title,
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Tooltip
      open={open}
      title={
        <Stack gap={2} p={12} sx={{ textOverflow: 'none' }}>
          <Text bold={true} variant="body1">
            {title}
          </Text>
          <Text sx={{ whiteSpace: 'unset' }} variant="body2">
            {body}
          </Text>
        </Stack>
      }
    >
      <IconButton
        aria-label={title}
        onClick={() => setOpen(!open)}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        sx={{
          minHeight: 0,
          minWidth: 0,
          p: 0,
        }}
      >
        <Icon name={iconName} sx={{ color: 'primary.main', fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  )
}

export default InformationTooltip
